import {_} from 'underscore';
//import axios from 'axios';
import $ from 'jquery';
import {loginRenew,logout} from '../Api/auth.es6';
(function() {
    //初期化
    const auth = JSON.parse(sessionStorage.getItem('auth'));
    let myLity;
    const $loader = $('#loader-wrap');
    $loader.css('display','block');
    if (auth !== null) {
        if (auth.hasOwnProperty('access_token') === true) {
            //$notice.html('ログインセッションを更新しています・・・');
            // ログインセッションが切断されています。もう一度ログインしなおしてください。
            loginRenew(auth.access_token)
                .then((result) => {
                    location.href = result.arrangements.current.url;
                })
                .catch((em) => {
                    //$notice.html('ログインセッションが切断されています。もう一度ログインしなおしてください');
                    location.href = '/';
                });
        } else {
            //$notice.html('ログインセッションが切断されています。もう一度ログインしなおしてください');
            location.href = '/';
        }
    } else {
        //$notice.html('ページが見つからないか、ログインセッションが切断されています。もう一度ログインしなおしてください');
        location.href = '/';
    }
    const showSnackBar = (message) => {
        const x = document.getElementById('snackBar');
        x.innerText = message;
        x.className = 'showSnack';
        setTimeout(function(){ x.className = x.className.replace('showSnack', ''); }, 3000);
    };
    const showErrorModal = (em) => {
        console.log(em);
        $('#loading-wrapper').hide();
        let error_message = '以下の項目をご確認ください。<br><br>';
        for (const m of em) {
            console.log(m);
            if (error_message !== '') {
                error_message = error_message + m + '<br>';
            } else {
                error_message = m + '<br>';
            }
        }
        $('#messageModalLabelError').html(error_message);
        myLity = lity('#messageModal');
    };
    $('.logout').on('click',function () {
        $loader.css('display','block');
        logout()
            .then(() => {
                location.href = '/';
            })
            .catch((em) => {
                $loader.css('display','none');
                showErrorModal([em]);
            })
    });

}());
